import { Component, h } from 'preact';

import { configGetLanguage } from 'common/helper/config/get-language';
import { GalleryScrollIndicatorComponentPropsInterface } from 'common/module/gallery-scroll-indicator/component-props.interface';
import { GalleryScrollIndicatorComponentStateInterface } from 'common/module/gallery-scroll-indicator/component-state.interface';
import { galleryScrollIndicatorGetItems } from 'common/module/gallery-scroll-indicator/get-items';
import { galleryScrollIndicatorGetVisibleIndexes } from 'common/module/gallery-scroll-indicator/get-visible-indexes';
import { GalleryScrollIndicatorTemplate } from 'common/module/gallery-scroll-indicator/template';
// TODO-FE[TPNX-593] - Refactor to more generic way
export class GalleryScrollIndicatorComponent extends Component<
  GalleryScrollIndicatorComponentPropsInterface,
  GalleryScrollIndicatorComponentStateInterface
> {
  /**
   * Constructor
   */
  constructor(props: GalleryScrollIndicatorComponentPropsInterface) {
    super(props);

    this.state = galleryScrollIndicatorGetVisibleIndexes({
      ...this.state,
      activeIndex: props.activeIndex,
      itemsCount: props.itemsCount,
      itemWidth: props.itemWidth,
      visibleItemsCount: props.visibleItemsCount,
    });
  }

  /**
   * @inheritdoc
   *
   * TODO-FE[https://pfinder.atlassian.net/browse/WEB-4794] - deprecated, use getDerivedStateFromProps
   */
  public componentWillReceiveProps(nextProps: GalleryScrollIndicatorComponentPropsInterface): void {
    this.setState(
      galleryScrollIndicatorGetVisibleIndexes({
        ...this.state,
        ...nextProps,
      })
    );
  }

  /**
   * @inheritdoc
   */
  public render(): preact.JSX.Element {
    const Template = this.props.template || GalleryScrollIndicatorTemplate;

    return (
      <Template
        items={galleryScrollIndicatorGetItems({
          ...this.state,
          activeIndex: this.props.activeIndex,
          itemsCount: this.props.itemsCount,
          isReversed: !!configGetLanguage().isRtl,
        })}
        isStatic={this.props.itemsCount <= this.props.visibleItemsCount}
        mainClass={this.props.mainClass}
        itemWidth={this.props.itemWidth}
      />
    );
  }
}
